import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Auth, User, onAuthStateChanged } from '@angular/fire/auth';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private auth: Auth,
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  // Funzione helper per ottenere l'utente una volta sola, come Promise
  private getCurrentUser(): Promise<User | null> {
    return new Promise((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(this.auth, user => {
        unsubscribe(); // disiscrivo il listener subito dopo la prima chiamata
        resolve(user);
      }, reject);
    });
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {

      const user = await this.getCurrentUser();

      if (!user) {
        console.warn('Utente non autenticato. Reindirizzamento al login.');
        await this.logOut(state);
        return false;
      }

      const token = await user.getIdTokenResult(true);
      const userRole = token.claims['role'];

      if (!token || new Date(token.expirationTime) < new Date()) {
        console.warn('Token scaduto. Reindirizzamento al login.');
        await this.logOut(state);
        return false;
      }

      const expectedRoles = route.data['expectedRoles'] as string[] | undefined;

      if (expectedRoles && (typeof userRole !== 'string' || !expectedRoles.includes(userRole))) {
        console.warn(`Accesso negato. Ruolo richiesto: ${expectedRoles.join(', ')}, ma l'utente ha ruolo: ${userRole}`);
        this.router.navigate(['/pri/report']); // o qualunque altra rotta
        return false;
    }

      return true;

    } catch (error) {
      console.error('Errore nella verifica dell\'autenticazione:', error);
      await this.logOut(state);
      return false;
    }
  }

  private async logOut(state?: RouterStateSnapshot): Promise<void> {
    await this.authService.logOut();
    this.router.navigate(['/login'], { queryParams: { returnUrl: state?.url } });
  }
}
